module.exports = __webpack_public_path__ + "static/media/ooca.cfc2c203.svg";